/* @flow */

import React from 'react';
import { Segment, Button } from 'semantic-ui-react';
import OrderDropdown from 'shared/components/OrderDropdown';
import type { NavigationContentLink } from 'catalog/plugins/nav/simple';

type Props = {
  link: NavigationContentLink,
  linkCount: number,
  onOrderChange: (link: NavigationContentLink, order: number) => void,
  onDelete: (link: NavigationContentLink) => void,
};

const NavigationLinkButtons = ({
  link,
  linkCount,
  onOrderChange,
  onDelete,
}: Props) => {
  const changeLinkOrder = newOrder => onOrderChange(link, newOrder);
  const deleteLink = () => onDelete(link);

  return (
    <Segment basic>
      <OrderDropdown
        value={link.order}
        orderCount={linkCount}
        onChange={changeLinkOrder}
      />
      <Button
        onClick={deleteLink}
        labelPosition="right"
        icon="remove"
        content="Supprimer"
        color="red"
        floated="right"
      />
    </Segment>
  );
};

export default NavigationLinkButtons;



// WEBPACK FOOTER //
// ./src/modules/catalog/plugins/nav/simple/components/NavigationLinkButtons.js